import React, { useState, useEffect } from "react";
import "./skill.css";
import history from "../../routes/history";
import ProgressBar from "../ProgressBar/ProgressBar";
import CandidateSignupButton from "../../pages/PostAJob/EmployerProfile/components/CandidateBackNext/CandidateSignupButton";
import { Select, Spin } from "antd";
import {
  fetchCandidateSkillInit,
  candidateDetailSuccess,
} from "../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { debounce } from "../../shared/helpers";
import errorIcon from "../../assets/img/ci_warning.png";
import SelectionItem from "../../pages/PostAJob/EmployerProfile/components/DesiredLocation/SelectionItem";
const CandidateSkills = () => {
  const dispatch = useDispatch();
  const { Option } = Select;

  const getInputValues = useSelector(
    (state) => state.candidateReducer.candidateDetails
  );
  const skillListings = useSelector(
    (state) => state.candidateSkillReducer.skills
  );
  const skillListingSkills =
    getInputValues?.skillListing?.skillListings_Skills || [];
  const loading = useSelector((state) => state.candidateSkillReducer.loading);

  const [selectedSkills, setSelectedSkills] = useState(skillListingSkills);
  const [skills, setSkills] = useState([]);
  const [noDataViewSkills, setNoDataViewSkills] = useState("");
  const [showError, setShowError] = useState(false);

  const userProfile = JSON.parse(localStorage.getItem("userProfile"));
  const professionCode = userProfile?.Professions?.ProfessionCode;

  useEffect(() => {
    if (skillListings.length) {
      setSkills(skillListings);
    } else {
      setSkills([]);
    }
  }, [skillListings]);

  const backFunction = () => {
    history.push("/gig-title");
  };
  const filterSkills = selectedSkills.map(({ _id, ...rest }) => rest)

  const nextFunction = () => {
    if (selectedSkills?.length) {
  dispatch(
        candidateDetailSuccess({
          ...getInputValues,
          skillListing: {
            ...(getInputValues?.skillListing || {}),
            skillListings_Skills: [...filterSkills],
          },
        })
      );
history.push("/location");
      setShowError(false);
    } else {
      setShowError(true);
      
    }
  };
  

  const skipFunction = () => {
    history.push("/location");
  };

  const onSelectSkill = (skill) => {
    try {
      const _selectedSkills = [...selectedSkills, JSON.parse(skill)];
      setSelectedSkills(_selectedSkills);
      // dispatch(
      //   candidateDetailSuccess({
      //     ...getInputValues,
      //     skillListing: {
      //       ...(getInputValues?.skillListing || {}),
      //       skillListings_Skills: [..._selectedSkills],
      //     },
      //   })
      // );
    } catch (error) {
      console.warn("error", error);
    }
  };

  const onDeselectSkill = (skill) => {
    try {
      const _selectedSkills = selectedSkills.filter(
        (el) => el.SkillName !== JSON.parse(skill).SkillName
      );
      setSelectedSkills(_selectedSkills);
      dispatch(
        candidateDetailSuccess({
          ...getInputValues,
          skillListing: {
            ...(getInputValues?.skillListing || {}),
            skillListings_Skills: [..._selectedSkills],
          },
        })
      );
    } catch (error) {
      console.warn("error", error);
    }
  };

  const onSearchSkills = (value) => {
    if (value !== "") {
      setNoDataViewSkills(value);
      dispatch(
        fetchCandidateSkillInit({ val: value, profCode: professionCode })
      );
    }
  };

  const locationPlaceholder = () => (
    <div className="placeholder-new-signup-loc-skill">
      <div className="example">ex.</div>
      <div className="circle-box">
        <span>Speciality Nurse</span>
      </div>
      <div className="circle-box">
        <span>Acute care</span>
      </div>
      <div className="circle-box Mobile-class">
        <span>Oncology</span>
      </div>
    </div>
  );

  return (
    <div className="profilecompleteion">
      <div>
        <ProgressBar
          heading={"Create candidate’s skill listing"}
          percent={60}
        />
        <div className="email-text">
          Your skills
          <div className="email-mandatory">(Optional)</div>
        </div>
        <div className="locat-sub">
          <span>List the key skills relevant to the candidate’s expertise</span>
        </div>
        <div className="skill-mobile">
          <Select
            mode="multiple"
            value={selectedSkills?.map((skill) => JSON.stringify(skill))}
            onSearch={debounce((val) => onSearchSkills(val), 700)}
            onSelect={onSelectSkill}
            onDeselect={onDeselectSkill}
            style={{ width: "100%" }}
            showSearch
            listHeight={160}
            autoFocus
            className={`desired-Skill${showError ? " skill-block" : ""}`}
            placeholder={locationPlaceholder()}
            tagRender={({ value }) => {
              const _tag = JSON.parse(value);
              return (
                <SelectionItem
                  title={_tag?.SkillName || "N/A"}
                  value={value}
                  onRemove={onDeselectSkill}
                />
              );
            }}
            notFoundContent={
              noDataViewSkills?.length > 0 ? (
                <div>
                  {loading || skills.length > 0 ? (
                    <Spin size="small" />
                  ) : (
                    "No data found!"
                  )}
                </div>
              ) : null
            }
          >
            {skills.map((skill) => (
              <Option value={JSON.stringify(skill)} key={skill.SkillName}>
                {skill.SkillName}
              </Option>
            ))}
          </Select>
        </div>
        {showError && (
          <div className="error-msg-content">
            <img src={errorIcon} alt="" />
            <span className="error-text">
              Please add your skills to continue
            </span>
          </div>
        )}
        <div style={{ paddingTop: "15%" }}>
          <CandidateSignupButton
            nextFunction={nextFunction}
            backFunction={backFunction}
            skipFunction={skipFunction}
          />
        </div>
      </div>
    </div>
  );
};

export default CandidateSkills;
